import React from "react";
import { Switch, Route, Link } from "react-router-dom";
import { Typography, Space, Layout, Button } from "antd";
import { CurrencyProvider } from "../src/services/currencyContext.js";

import {
  Navbar,
  Exchanges,
  Homepage,
  Cryptocurrencies,
  News,
  CryptoDetails,
  LineChart,
  Statitics,
} from "./componets";
import "./App.css";

const { Header, Content, Footer, Sider } = Layout;

const App = () => {
  return (
    <CurrencyProvider>
      <div className="app">
        <Layout hasSider>
          <Layout>
            <Header style={{ backgroundColor: "#DFDFDE" }}>
              <Button>Select Currency</Button>
            </Header>

            <Sider
              width="250"
              style={{
                backgroundColor: "#3A3845",
                overflow: "auto",
                height: "100vh",
                position: "fixed",
                left: 0,
                top: 0,
                bottom: 0,
              }}
            >
              <Navbar />
            </Sider>

            <div className="Switch">
              <Content theme="dark" style={{ backgroundColor: "#F7F7F7" }}>
                <Switch>
                  <Route exact path="/">
                    <Homepage />
                  </Route>
                  <Route exact path="/exchanges">
                    <Statitics />
                  </Route>
                  <Route exact path="/cryptoStats/:id">
                    <LineChart />
                  </Route>
                  <Route exact path="/cryptoCurrencies">
                    <Cryptocurrencies />
                  </Route>
                  <Route exact path="/crypto/:uuid">
                    <CryptoDetails />
                  </Route>
                  <Route exact path="/news">
                    <News />
                  </Route>
                </Switch>
                <Footer>
                  {" "}
                  <Typography.Title level={4}>
                    Live Crypto <br />
                  </Typography.Title>
                  <span style={{ marginRight: "20px" }}>
                    All rights reserved
                  </span>
                  <Space>
                    <Link to="/">Home</Link>
                    <Link to="/cryptoCurrencies">Crypto Info</Link>
                    <Link to="/news">News</Link>
                  </Space>
                </Footer>
              </Content>
            </div>
          </Layout>
        </Layout>
      </div>
    </CurrencyProvider>
  );
};

export default App;
